import {Pipe, PipeTransform} from '@angular/core';
import { DateHelpers, DEFAULT_DISPLAY_DATE } from '@edl-development/edl-common';
@Pipe({
    name: 'monthDayDisplay',
    pure: false
})
export class MonthDayDisplayPipe implements PipeTransform {
    constructor() {}

    transform(date: string | Date): string {
        const _date = this.transformDate(date);

        if (!_date || !(_date instanceof Date) || isNaN(_date.getTime()) || DateHelpers.isMinDate(_date)) {
            return DEFAULT_DISPLAY_DATE;
        }

        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
          ];
        
          var day = _date.getDate();
          var monthIndex = _date.getMonth();
        
          return monthNames[monthIndex] +' '+ day  ;
    }

    private transformDate(date: string | Date) {
        if (!date) {
            return null;
        }
        else if (date instanceof Date) {
            return date;
        } else if (DateHelpers.isShortDate(date)) {
            return DateHelpers.shortDateStringToDate(date);
        } else {
            return new Date(date);
        }
    }
}